<template>
  <div
    :class="[$style.animation, strokeColor && $style.stroke]"
    :style="[style, strokeColor && cssStroke]"
    ref="animation"
  ></div>
</template>

<script>
import lottie from 'lottie-web'

export default {

  emits: [
    'animationCreated',
  ],
  props: {
    name: {
      type: String,
      required: true,
    },
    height: Number,
    width: Number,
    strokeColor: String,
  },

  data () {
    return {
      animation: null,
      style: {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%',
      },
    }
  },

  computed: {
    cssStroke () {
      return {
        '--stroke-color': this.strokeColor,
      }
    },
  },

  async mounted () {
    const animationData = await import(`../../assets/lottie/${this.name}.json`)
    this.animation = lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    })
    this.$emit('animationCreated', this.animation)
  },
}
</script>

<style lang="scss" module>
.animation {
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  > svg {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.stroke {
  path {
    stroke: var(--stroke-color)
  }
}
</style>
